{
  "validation": {
    "vatNumber": {
      "empty": "EXAMPLE: Please, enter the VAT NUMBER",
      "not_positive": "EXAMPLE: the max length is {{maxLength}} of field {{field}}",
      "invalid_email": "EXAMPLE: $t(rules.empty, { 'field': {{field, lowercase}} })"
    }
  },
  "rules": {
    "empty": "{{field}} ist verpflichtend anzugeben",
    "duplicate_name": "Dieser Name ist bereits vergeben",
    "length": "Die Länge von {{field}} sollte {{length}} Zeichen betragen",
    "min_length": "{{field}} muss mindestens {{minLength}} Zeichen lang sein",
    "max_length": "{{field}} darf nicht länger als {{maxLength}} Zeichen sein",
    "invalid": "Der Name muss mit einem Buchstaben beginnen und mit einem Buchstaben oder einer Ziffer enden. Er darf Leerzeichen, Punkte und Bindestriche enthalten.",
    "trailing_whitespace": "Leerzeichen am Ende sind nicht erlaubt",
    "beginning_whitespace": "Leerzeichen am Anfang sind nicht erlaubt",
    "invalid_email": "Geben Sie eine gültige E-Mail ein",
    "invalid_password": "Das Passwort muss mindestens 8 Zeichen enthalten, davon einen Kleinbuchstaben, einen Großbuchstaben und eine Ziffer",
    "passwords_no_match": "Passwörter stimmen nicht überein",
    "after_max_date": "{{field}} darf nicht nach {{maxDate}} sein",
    "before_min_date": "{{field}} darf nicht vor {{minDate}} sein",
    "invalid_date": "Ungültiges Datumsformat",
    "invalid_time": "Ungültiges Zeitformat",
    "later_than": "{{field}} muss später als {{laterThan}} sein",
    "not_positive": "{{field}} muss positiv sein",
    "more_than": "{{field}} muss größer als {{moreThan}} sein",
    "less_than": "{{field}} muss kleiner als {{lessThan}} sein",
    "more_than_or_equal": "{{field}} muss größer oder gleich {{moreThan}} sein",
    "less_than_or_equal": "{{field}} muss kleiner oder gleich {{lessThan}} sein",
    "illegal_property": "Ungültiges Feld",
    "integer": "{{field}} muss eine ganze Zahl sein",
    "invalid_url": "Die angegebene URL ist ungültig, bitte das richtige Format verwenden (z. B. https://example.com)",
    "invalid_domain": "Geben Sie eine gültige Domain ein",
    "unique_arr": "{{field}} sollte nur eindeutige Werte enthalten",
    "max_arr_length": "{{field}} darf nur {{maxLength}} Zeichen enthalten",
    "subnet_mask_not_valid": "Ungültige IPv4 Netzwerk Adresse (gültiges Format: 10.0.0.0/16)",
    "either_or": "Bitte gib entweder {{field}} oder {{field2}} an"
  }
}
